import React from "react";

/**
 * Tactical button with sharp edges + neon glow.
 * variants: primary (cyan), accent (pink), danger (rose), ghost (slate)
 */
const TButton = React.forwardRef(({ children, variant = "primary", className = "", icon: Icon, ...rest }, ref) => {
  const variants = {
    primary: "border-cyan-500/60 text-cyan-300 bg-cyan-500/5 hover:bg-cyan-500/15 hover:border-cyan-400 hover:shadow-[0_0_18px_rgba(6,182,212,0.4)]",
    accent: "border-fuchsia-500/60 text-fuchsia-300 bg-fuchsia-500/5 hover:bg-fuchsia-500/15 hover:border-fuchsia-400 hover:shadow-[0_0_18px_rgba(217,70,239,0.4)]",
    danger: "border-rose-500/60 text-rose-300 bg-rose-500/5 hover:bg-rose-500/15 hover:border-rose-400 hover:shadow-[0_0_18px_rgba(244,63,94,0.4)]",
    ghost: "border-slate-700 text-slate-300 hover:border-slate-500 hover:text-white",
    solid: "border-cyan-400 bg-cyan-400 text-slate-950 hover:bg-cyan-300",
  };
  return (
    <button
      ref={ref}
      className={[
        "inline-flex items-center justify-center gap-2 px-4 py-2 border text-[11px] font-bold tracking-widest uppercase transition-all duration-200 rounded-sm font-mono disabled:opacity-40 disabled:cursor-not-allowed",
        variants[variant] || variants.primary,
        className,
      ].join(" ")}
      {...rest}
    >
      {Icon && <Icon className="h-3.5 w-3.5" strokeWidth={2} />}
      {children}
    </button>
  );
});
TButton.displayName = "TButton";

export default TButton;
